import NumberFlow from "@number-flow/react";
import { Minus, Plus } from "lucide-react";

type ArticleQuantityProps = {
  onChange?: (value: number) => void;
  quantity: number;
  maxQuantity: number;
  productPrice: number;
};

export function ArticleNonEditableQuantity({ quantity }: { quantity: number }) {
  return (
    <span className="text-xs font-bold text-muted-foreground inline-block text-center min-w-[6ch]">
      ×{quantity}
    </span>
  );
}

export function ArticleQuantity({
  maxQuantity,
  quantity,
  onChange,
}: ArticleQuantityProps) {
  const editable = !!onChange;

  const handleDecrement = () => {
    if (quantity > 0) {
      const next = quantity - 1;
      onChange?.(next);
    }
  };

  const handleIncrement = () => {
    const next = Math.min(maxQuantity, quantity + 1);
    onChange?.(next);
  };

  if (!editable) {
    return null;
  }

  return (
    <ArticleEditableQuantity
      value={quantity}
      onIncrement={handleIncrement}
      onDecrement={handleDecrement}
      max={maxQuantity}
    />
  );
}

type ArticleEditableQuantityProps = {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  max: number;
};

function ArticleEditableQuantity({
  value,
  onIncrement,
  onDecrement,
  max,
}: ArticleEditableQuantityProps) {
  return (
    <div className="bg-muted rounded-full items-center flex px-2">
      <button
        type="button"
        role="button"
        className="py-2 rounded-full"
        onClick={onDecrement}
      >
        <Minus className="size-4" />
      </button>
      <span className="text-xs font-bold text-muted-foreground inline-block text-center min-w-[6ch]">
        <NumberFlow value={value} suffix={` / ${max}`} />
      </span>
      <button
        role="button"
        type="button"
        className="rounded-full py-2"
        onClick={onIncrement}
      >
        <Plus className="size-4" />
      </button>
    </div>
  );
}
